import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Tooltip from 'components/core/Tooltip';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import { icon as entityIcon, attributes } from 'models/entity';
import { icon as installationIcon, isAdminEntity } from 'models/installation';
import mProduct from 'models/product';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';
import { OneparkLogoImg } from 'components/img/AssetImg';

const EntityIcon = ({ entity }) => {
  // Permissions
  const { pAdmin } = permissions;

  // Entity attributes
  const isAdmin = isAdminEntity(entity);
  const { isMaster, hostsOneparkBookings } = attributes(entity);

  // Product
  const product = !isAdmin ? mProduct.fromConfigurationValue(entity.product) : null;

  // Return the right icon according to entity attributes
  // Master
  if (isMaster) {
    return (
      <AppIcon id={installationIcon} defaultColor />
    );
  }

  // Onepark bookings
  if (hostsOneparkBookings) {
    return (
      <div style={{ width: 24, height: 24 }} className="text-center">
        {OneparkLogoImg(null, 24)}
      </div>
    );
  }

  // Regular
  return (
    <OnlyWith
      permissions={{
        needed: pAdmin,
      }}
      alternativeComponent={<AppIcon id={entityIcon} defaultColor />}
    >
      <Tooltip content={<LocalizedMessage id={product.labelId} />}>
        <AppIcon defaultColor id={product.icon} />
      </Tooltip>
    </OnlyWith>
  );
};

EntityIcon.propTypes = {
  entity: entityDataShape.isRequired,
};

module.exports = EntityIcon;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/entities/EntityIcon.js